import createStorage from '../utils/cache'

class Storage {
  create(name, options = {}) {
    if (!name) {
      throw new Error('storage name is empty')
    }

    const prefix = options.prefix || ''

    const storageName = prefix
      ? `${prefix}_${name}`
      : name

    return createStorage(storageName, options)
  }
}

export default Storage